import React, { useRef, useState, useEffect } from 'react';
import * as cls from './how-it-works.module.css';
import { Typography } from '../../../ui/components/typography/typography';
import { IMG_PATH, ROUTES_PATHS } from '../../../constants';
import { Link } from 'react-router-dom';
import { Button } from '../../../ui/components/button';

export const HowItWorks = () => {
  const sectionRef = useRef(null);
  const [animatedItems, setAnimatedItems] = useState(new Set());
  const [imageAnimated, setImageAnimated] = useState(false);
  const [buttonAnimated, setButtonAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const contentItems = sectionRef.current?.querySelectorAll(
            `.${cls.wrapper} > div:first-child > p, .${cls.wrapper} > div:first-child > ul`,
          );
          if (contentItems) {
            contentItems.forEach((item, index) => {
              setTimeout(() => {
                setAnimatedItems((prev) => new Set(prev).add(index));
              }, index * 200);
            });
          }

          setTimeout(() => {
            setImageAnimated(true);
          }, 800);

          setTimeout(() => {
            setButtonAnimated(true);
          }, 1200);
        }
      },
      {
        threshold: 0.4,
        rootMargin: '-50px 0px',
      },
    );

    const currentSection = sectionRef.current;
    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  return (
    <div ref={sectionRef}>
      <Typography className={cls.title} tag="h2">
        Hardware That Fits Your Home
      </Typography>

      <div className={cls.wrapper}>
        <div>
          <Typography
            className={animatedItems.has(0) ? cls.animated : cls.hiddenLeft}
          >
            <strong>A Compact Device with Powerful Insights</strong>
          </Typography>
          <Typography
            className={animatedItems.has(1) ? cls.animated : cls.hiddenLeft}
          >
            Voltaware's home energy monitor is a small, smart sensor that fits
            inside your fusebox. Once installed, it connects to your Wi-Fi and
            starts measuring electricity usage across your entire home in real
            time.
          </Typography>
          <Typography
            className={animatedItems.has(2) ? cls.animated : cls.hiddenLeft}
          >
            <b>What's included:</b>
          </Typography>
          <ul className={animatedItems.has(3) ? cls.animated : cls.hiddenLeft}>
            <li>
              <Typography>
                A lightweight sensor that clips around your main electricity
                cable
              </Typography>
            </li>
            <li>
              <Typography>
                A transmitter that sends data securely to the cloud
              </Typography>
            </li>
            <li>
              <Typography>A power adapter and setup guide</Typography>
            </li>
          </ul>
        </div>
        <div>
          <img
            src={`${IMG_PATH}/home/how-it-works.png`}
            alt="how voltaware sensor works"
            className={imageAnimated ? cls.animatedImage : cls.hiddenImage}
          />
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Link
          to={ROUTES_PATHS.OUR_TECHNOLOGY}
          className={buttonAnimated ? cls.animatedButton : cls.hiddenButton}
        >
          <Button size="sm" variant="green-transparent">
            See How it Works
          </Button>
        </Link>
      </div>
    </div>
  );
};
